module.exports = __webpack_public_path__ + "static/media/shape2.svg:Zone.7a821669.Identifier";